// removed by extract-text-webpack-plugin
module.exports = {"cell":"SubjectsListPage__cell___1tgyP","isNotTreatmentAdherent":"SubjectsListPage__isNotTreatmentAdherent___2M9GO","requestInfo":"SubjectsListPage__requestInfo___1PA8P","requestInfoButton":"SubjectsListPage__requestInfoButton___14ltM","pageTitle":"SubjectsListPage__pageTitle___3FZvU","isTechnicianNoPhysicians":"SubjectsListPage__isTechnicianNoPhysicians___1abJ6","highlightExplanation":"SubjectsListPage__highlightExplanation___1vwp2","subjectTable":"SubjectsListPage__subjectTable___D_0wO","sortableColumn":"SubjectsListPage__sortableColumn___1H2g4","archived":"SubjectsListPage__archived___Hq-U4"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/pages/SubjectsListPage.css
// module id = 1223
// module chunks = 0